export default {
  RECEIVED_EXPORT: "RECEIVED_EXPORT",
  RECEIVED_EXPORT_LIST: "RECEIVED_EXPORT_LIST",
  CLONE_EXPORT: "CLONE_EXPORT",
  SET_MODE: "SET_MODE",
  FETCHING_GEONAMES: "FETCHING_GEONAMES",
  RECEIVED_GEONAMES: "RECEIVED_GEONAMES",
  FETCH_GEONAMES_ERROR: "FETCH_GEONAMES_ERROR",
  FETCHING_NOMINATIM: "FETCHING_NOMINATIM",
  RECEIVED_NOMINATIM: "RECEIVED_NOMINATIM",
  FETCH_NOMINATIM_ERROR: "FETCH_NOMINATIM_ERROR",
  SHOW_INVALID_DRAW_WARNING: "SHOW_INVALID_DRAW_WARNING",
  HIDE_INVALID_DRAW_WARNING: "HIDE_INVALID_DRAW_WARNING",
  RECEIVED_RUNS: "RECEIVED_RUNS",
  FETCHING_EXPORT: "FETCHING_EXPORT",
  FETCHING_EXPORT_FAILED: "FETCHING_EXPORT_FAILED",
  FETCHING_EXPORT_LIST: "FETCHING_EXPORT_LIST",
  FETCHING_EXPORT_LIST_FAILED: "FETCHING_EXPORT_LIST_FAILED",
  FETCHING_EXPORT_REGION: "FETCHING_EXPORT_REGION",
  FETCHING_EXPORT_REGIONS: "FETCHING_EXPORT_REGIONS",
  RECEIVED_EXPORT_REGION: "RECEIVED_EXPORT_REGION",
  RECEIVED_EXPORT_REGIONS: "RECEIVED_EXPORT_REGIONS",
  FETCHING_PERMISSIONS: "FETCHING_PERMISSIONS",
  FETCHING_PERMISSIONS_FAILED: "FETCHING_PERMISSIONS_FAILED",
  FETCH_EXPORT_REGIONS_ERROR: "FETCH_EXPORT_REGIONS_ERROR",
  STARTING_EXPORT_REGION_RUN: "STARTING_EXPORT_REGION_RUN",
  EXPORT_REGION_RUN_STARTED: "EXPORT_REGION_RUN_STARTED",
  EXPORT_REGION_RUN_ERROR: "EXPORT_REGION_RUN_ERROR",
  STARTING_EXPORT_REGION_DELETE: "STARTING_EXPORT_REGION_DELETE",
  EXPORT_REGION_DELETED: "EXPORT_REGION_DELETED",
  DELETE_EXPORT_REGION_ERROR: "DELETE_EXPORT_REGION_ERROR",
  ZOOM_TO_EXPORT_REGION: "ZOOM_TO_EXPORT_REGION",
  EXPORT_REGION_CREATED: "EXPORT_REGION_CREATED",
  EXPORT_REGION_UPDATED: "EXPORT_REGION_UPDATED",
  RECEIVED_OVERPASS_TIMESTAMP: "RECEIVED_OVERPASS_TIMESTAMP",
  RECEIVED_GALAXY_TIMESTAMP: "RECEIVED_GALAXY_TIMESTAMP",
  RECEIVED_PERMISSIONS: "RECEIVED_PERMISSIONS",
  RECEIVED_CONFIGURATIONS_LIST: "RECEIVED_CONFIGURATIONS_LIST",
  RECEIVED_CONFIGURATION: " RECEIVED_CONFIGURATION",
  SET_BOX_SELECTED: "SET_BOX_SELECTED",
  SET_FREE_SELECTED: "SET_FREE_SELECTED",
  SET_VIEW_SELECTED: "SET_VIEW_SELECTED",
  SET_IMPORT_SELECTED: "SET_IMPORT_SELECTED",
  SET_SEARCH_SELECTED: "SET_SEARCH_SELECTED",
  SET_BUTTONS_DEFAULT: "SET_BUTTONS_DEFAULT",
  SET_IMPORT_MODAL_STATE: "SET_IMPORT_MODAL_STATE",
  FILE_PROCESSING: "FILE_PROCESSING",
  FILE_PROCESSED: "FILE_PROCESSED",
  FILE_ERROR: "FILE_ERROR",
  FILE_RESET: "FILE_RESET",
  FETCHING_LOCATION_OPTIONS: "FETCHING_LOCATION_OPTIONS",
  FETCHING_LOCATION_OPTIONS_FAILED: "FETCHING_LOCATION_OPTIONS_FAILED",
  RECEIVED_LOCATION_OPTIONS: "RECEIVED_LOCATION_OPTIONS",
  RUNNING_EXPORT: "RUNNING_EXPORT",
  EXPORT_DELETED: "EXPORT_DELETED",
  CONFIGURATION_CREATED: "CONFIGURATION_CREATED",
  CONFIGURATION_UPDATED: "CONFIGURATION_UPDATED",
  CONFIGURATION_DELETED: "CONFIGURATION_DELETED",
  FETCHING_CONFIGURATIONS: "FETCHING_CONFIGURATIONS",
  FETCHING_GROUPS: "FETCHING_GROUPS",
  FETCHING_GROUPS_FAILED: "FETCHING_GROUPS_FAILED",
  RECEIVED_GROUPS: "RECEIVED_GROUPS",
  RECEIVED_STATS: "RECEIVED_STATS"
};



// WEBPACK FOOTER //
// ./app/actions/index.js